var _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgr1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7409 112.672H89.2591C95.7434 112.672 101 107.416 101 100.931V93.3759C101 90.9702 100.277 88.6095 98.6205 86.8649C94.9132 82.9599 87.014 76.3807 75.9138 76.4379C64.8325 76.4949 57.0263 83.0055 53.3617 86.8753C51.7159 88.6132 51 90.9629 51 93.3565V100.931C51 107.416 56.2566 112.672 62.7409 112.672Z",
    fill: "#8FBC84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.9998,
    cy: 59.9393,
    r: 19.9393,
    fill: "#8FBC84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.283,
    cy: 57.3084,
    r: 5.16194,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.283,
    cy: 57.3084,
    r: 5.16194,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1092,
    cy: 57.3084,
    r: 5.16194,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1092,
    cy: 57.3084,
    r: 5.16194,
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1031 91.7031V102.312C85.9626 101.382 81.6816 99.6318 81.6816 94.4946C81.6816 89.3575 86.9863 88.9114 88.1031 91.7031Z",
    fill: "#6C9D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.102 91.7031V102.312C90.2425 101.382 94.5234 99.6318 94.5234 94.4946C94.5234 89.3575 89.2188 88.9114 88.102 91.7031Z",
    fill: "#6C9D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgr1);
export default __webpack_public_path__ + "static/media/agr-1.533a90065e7a2f391fd97c4ffc881158.svg";
export { ForwardRef as ReactComponent };